<template>
  <div>
    <h4 class="font-weight-700 mb-3">{{ question.prompt }}</h4>
    <div class="list-group">
      <button
        v-for="(option, index) in (question.options || [])"
        :key="option.id"
        type="button"
        class="option-item list-group-item text-left mb-3 py-3 rounded-box"
        @click="select(option)"
        :disabled="disabled"
        :class="{ 'is-selected': selectedOptionId === option.id }"
      >
        <span
          class="option-radio mr-3"
          :class="{ selected: selectedOptionId === option.id }"
        ></span>

        <strong class="mr-2">
          {{ String.fromCharCode(65 + index) }}.
        </strong>

        <span class="option-text">{{ option.text }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "pregunta-respuesta-multiple",

  props: {
    question: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
    value: { type: [String, Number], default: null }
  },

  computed: {
    selectedOptionId() {
      return this.value;
    }
  },

  methods: {
    select(option) {
      if (this.disabled) return;
      this.$emit("input", option.id);
    }
  }
};
</script>

<style scoped>
.option-item {
  display: flex;
  align-items: center;
  font-size: 20px;
  transition: background-color 0.15s ease, border-color 0.15s ease;
  border: 1px solid rgba(0,0,0,0.125);
  background: #fff;
}
.option-item:hover:not(:disabled) {
  background-color: #f3f8ff;
}
.option-item:focus {
  outline: none;
  box-shadow: none;
}
.option-item:disabled {
  opacity: 0.75;
  cursor: not-allowed;
}
.option-item.is-selected {
  border-color: #2484da;
  background-color: #eef6ff;
}
.option-radio {
  width: 18px;
  height: 18px;
  border: 2px solid #2484da;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  flex-shrink: 0;
}
.option-radio.selected::after {
  content: "";
  width: 10px;
  height: 10px;
  background-color: #2484da;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
